import { Panel } from '@wdg/blocks/panels-view-script';

document.querySelectorAll( '.aside-navigation__item--panel' ).forEach( ( node ) => {
	new Panel( node, {
		interactiveClass: 'aside-navigation__item--interactive',
		title: '.aside-navigation__link--toggle',
		content: '.aside-navigation__items',
		openedClass: 'aside-navigation__item--opened',
	} );
} );
